import * as axios from '../../axios-extended'
import * as t from 'io-ts'
import { PeriodInfoData, PeriodSummary } from './types'

const apiUrl = '/prosperbill/api'

export const getDCNNymID = (cancelToken?: axios.CancelToken) =>
  axios.get('/dcn/dcn1.0/nym-id', { cancelToken, decoder: t.string })

export const getPeriodInformation = (
  organization: string,
  { page = 0, itemsPerPage = 10 },
  cancelToken?: axios.CancelToken
) =>
  axios.get(`${apiUrl}/invoices/${organization}/periods`, {
    cancelToken,
    params: { page, itemsPerPage },
    decoder: PeriodInfoData,
  })

export const getPeriodSummary = (
  organization: string,
  cancelToken?: axios.CancelToken
) =>
  axios.get(`${apiUrl}/invoices/${organization}/summary`, {
    cancelToken,
    decoder: PeriodSummary,
  })
